import { render, staticRenderFns } from "./main.concepto-digitacion.vue?vue&type=template&id=5f9de029"
import script from "./main.concepto-digitacion.vue?vue&type=script&lang=js"
export * from "./main.concepto-digitacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports